import { render, staticRenderFns } from "./Cx3PbxPricing.vue?vue&type=template&id=d49132e2&"
import script from "./Cx3PbxPricing.vue?vue&type=script&lang=js&"
export * from "./Cx3PbxPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports